import { render, staticRenderFns } from "./Pratiche.vue?vue&type=template&id=b11dedde"
import script from "./Pratiche.vue?vue&type=script&lang=js"
export * from "./Pratiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports